import { motion } from "framer-motion";
import { CHAPTERS, SITE } from "../config";

export const Manifesto = () => {
  return (
    <section id="chapters" data-testid="chapters-section" className="relative bg-[#12100a] border-y border-[#d8ab4e]/15 py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
          <div className="lg:col-span-8">
            <p className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">Inside the Pages</p>
            <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[0.9]">
              Fourteen chapters toward a <span className="gold-text italic">golden</span> future.
            </h2>
          </div>
          <p className="lg:col-span-4 font-body text-[#9a8f78] text-lg">
            A {SITE.pages} non-fiction journey — from the world's stark truth to the prosperity waiting on our doorstep.
          </p>
        </div>

        {/* Table of contents */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 border-t border-[#d8ab4e]/15">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`chapter-${c.n}`}
              className="group flex items-baseline gap-6 py-6 border-b border-[#d8ab4e]/15"
            >
              <span className="font-grotesk text-4xl md:text-5xl font-black text-outline group-hover:[color:#d8ab4e] group-hover:[-webkit-text-stroke:0] transition-all duration-500 w-20 shrink-0">
                {c.n}
              </span>
              <span className="font-display italic text-2xl md:text-3xl text-[#f3ead6] group-hover:text-[#f2c968] transition-colors">
                {c.title}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Pull quote from the manuscript */}
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9 }}
          data-testid="excerpt-quote"
          className="mt-20 md:mt-32 max-w-4xl"
        >
          <p className="font-display italic text-3xl sm:text-5xl leading-[1.15] text-[#f3ead6]">
            <span className="gold-text">“</span>
            {SITE.excerpt}
            <span className="gold-text">”</span>
          </p>
          <footer className="mt-8 font-grotesk uppercase tracking-[0.3em] text-xs text-[#d8ab4e]">
            — {SITE.author}, from the opening pages
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
};

export default Manifesto;
